
import { Component, OnInit, OnDestroy, ViewEncapsulation } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { PageLoaderService } from 'lib/ng2-sapmp/src/ui-components';
import { BreadCrumbService } from 'lib/ng2-sapmp/src/ui-components/breadcrumb';
import { ProductConfiguratorService } from '../../product-configurator/shared';
import { AuthenticationService, UtilityService, ValidationService, LicensePricingService } from 'lib/ng2-sapmp/src/providers';
import { ReviewOrderProductModel } from '../review-order-product';
import { UserWizardModel } from 'lib/ng2-sapmp/src/models/user-wizard';
import { UserProfileModel } from 'lib/ng2-sapmp/src/models/userprofile';
import { ANALYTICS_CONSTANTS } from 'config';
import { AdobeAnalyticsService } from 'lib/ng2-sapmp/src/providers';
import { MobilePivotModel } from 'lib/ng2-sapmp/src/ui-components/mobile-pivot/mobile-pivot.model';
declare var ENV_VAR: any; // global variable set in env.js file, imported in index.html
declare var logoutCurrentUser: any;
declare var ENV_PORTAL;
const ENV_PORTAL_DOMAIN = (ENV_PORTAL === 'fnabc') ? 'FN' : 'ABC';
@Component({
  selector: 'app-increase',
  providers: [ValidationService, ProductConfiguratorService, LicensePricingService, AdobeAnalyticsService],
  templateUrl: './modify-license.component.html',
  styleUrls: ['./modify-license.component.scss'],
})
export class ModifyLicenseComponent implements OnInit, OnDestroy {
  dataLayer: {};
  modifyLicenseForm: FormGroup;
  formErrors = {
    'qty': ''
  };
  validationMessages = {
    'qty': {
      'required': 'Enter the number of licenses to .',
      'pattern': 'Enter the number of licenses to .'
    }
  };
  setError = false;
  ErrorMessage = '';
  producDetails: any = null;
  initialQty = 1;
  updatedQty = 1;
  totalQty = 1;
  tmpTotalQty = 1;
  dataObj = {
    dcmCodes: [],
    quantity: 0,
    fan: ''
  };
  productInfo = {
    productName: '',
    fan: '',
    ctn: '',
    dcmCode: '',
    clientId: ''
  };
  OwnedProductData = {
    credentialType: 'MOBILEIDENTIFIER',
    credentialId: '',
    dcmCode: ''
  };
  showErrLink = false;
  ownedProductPrice = 0;
  UpdatedQtyAmt = 0;
  TotalAmt = 0;
  reviewModel: ReviewOrderProductModel;
  userWizard: UserWizardModel;
  licenseModifyType = '';
  validationLicenseModifyType = '';
  title = '';
  impoErr = false;
  priceErr = false;
  unitPrice = 0;
  totUnitPrice = 0;
  showVolumeDiscunt = false;
  volumeDiscount = [];
  subscriptionId: string;
  isFormValid: boolean;
  user: UserProfileModel;
  showRemoveallLink = false;
  pivots: Array<MobilePivotModel>;
  licenseType = '';
  feeType: string;
  estimatedAmount: number;
  unitTotalEstimatedAmount: number;
  errorFlag = false;
  billingClientId: string;
  constructor(private route: ActivatedRoute,
    private router: Router,
    private formBuilder: FormBuilder,
    private validationService: ValidationService,
    private productConfiguratorService: ProductConfiguratorService,
    private utilityService: UtilityService,
    private licensePricingService: LicensePricingService,
    private http: HttpClient, private pageloaderService: PageLoaderService, private breadCrumbService: BreadCrumbService,
    private adobeAnalyticsService: AdobeAnalyticsService) {
    this.isFormValid = false;
    this.pivots = new Array<MobilePivotModel>();
    this.estimatedAmount = 0;
    this.unitTotalEstimatedAmount = 0;
  }

  ngOnInit() {
    this.pivots.push({ label: 'Manage Products', routerLink: '/manage' });
    this.pivots.push({ label: 'Console dashboard', routerLink: '/dashboard' });
    if (sessionStorage.getItem('singleUserDetail') === null) {
      this.router.navigate(['/home']);
    } else {
      document.body.classList.add('manageproduct-page');
      document.title = (ENV_PORTAL_DOMAIN === 'FN') ? 'Apps & Solutions - Manage Product ' : 'AT&T Business Console - Manage Product';


      if (!!sessionStorage.getItem('singleUserDetail')) {
        this.producDetails = JSON.parse(sessionStorage.getItem('singleUserDetail'));
        this.billingClientId = this.utilityService.formatTelephoneNumber(this.producDetails.billingClientId);
        this.ownedProductPrice = 0;
      }
      if (this.producDetails.modifyType === 'Increase') {
        this.licenseModifyType = 'Add';
        this.validationLicenseModifyType = 'add';
        this.licenseType = 'Increase number of';
        this.title = ' Manage Product - Increase license';
        this.breadCrumbService.setCurrentBreadCrumb({ label: 'Add licenses', routerLink: '/manageProduct/modifyLicense' });
      } else {
        this.licenseModifyType = 'Remove';
        this.validationLicenseModifyType = 'remove';
        this.licenseType = 'Decrease number of';
        this.title = ' Manage Product - Decrease license';
        this.breadCrumbService.setCurrentBreadCrumb({ label: 'Decrease number of licenses', routerLink: '/manageProduct/modifyLicense' });
      }
      this.validationMessages = {
        'qty': {
          'required': 'Enter the number of licenses to ' + this.validationLicenseModifyType + '.',
          'pattern': 'Enter the number of licenses to ' + this.validationLicenseModifyType + '.'
        }
      };

      if (!!sessionStorage.getItem('reviewModel')) {
        const reviewModel = JSON.parse(sessionStorage.getItem('reviewModel'));
        this.initialQty = reviewModel.modifiedLicense;
      } else {
        if (this.producDetails.enteredQty !== undefined) {
          this.initialQty = this.producDetails.enteredQty;
          console.log('init qty : ' + this.initialQty);
        }
      }
      this.user = JSON.parse(sessionStorage.getItem('user')).user;
      this.buildForm();
      this.getOwnedProductInfo();
      this.createPageLoadProperties(this.producDetails.serviceOfferCode,
        this.router.routerState.snapshot.url,
        this.title);
    }
  }

  // Page Load adobe analytics
  createPageLoadProperties(dcmcodes, url: string, title: string) {
    const dataLayer = {};
    if (this.licenseModifyType === 'Add') {
      dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_FRIENDLY_PAGE_NAME] = ANALYTICS_CONSTANTS.FRIENDLY_NAME_INCREASE_LICENSE;
      dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_FLOW_CODE] = ANALYTICS_CONSTANTS.FLOW_CODE_LICENSE_MANAGEMNET_INCREASE;
    } else {
      dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_FRIENDLY_PAGE_NAME] = ANALYTICS_CONSTANTS.FRIENDLY_NAME_DECREASE_LICENSE;
      dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_FLOW_CODE] = ANALYTICS_CONSTANTS.FLOW_CODE_LICENSE_MANAGEMNET_DECREASE;
    }

    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_LANGUAGE] = 'EN';
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_SKU] = dcmcodes;
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_USER_LOGIN_SOURCE] = 'shoplogin';
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_PAGE_FUNCTION] = 'Service';
    if (ENV_PORTAL === 'fnabc') {
      dataLayer[ANALYTICS_CONSTANTS.GLOBAL_USER_FIRSTNET_FLAG] = ANALYTICS_CONSTANTS.EVENTS_SUCCESSFLAG_1;
      dataLayer[ANALYTICS_CONSTANTS.GLOBAL_USER_FIRST_NET_USER_ROLE] = ANALYTICS_CONSTANTS.GLOBAL_USER_FIRST_NET_USER_ROLE_VALUE;
    }
    this.adobeAnalyticsService.tag('page', dataLayer, 'Page_Load', 'pageLoad');
  }

  buildForm(): void {
    this.modifyLicenseForm = this.formBuilder.group({
      qty: [this.initialQty,
      [Validators.required,
      Validators.pattern('^[1-9][0-9]{0,4}$')]]
    });

    this.validationService.validate(
      this.modifyLicenseForm,
      this.formErrors,
      this.validationMessages);
  }
  getOwnedProductInfo() {
    this.pageloaderService.setPageLoaderStatus(false);
    this.impoErr = false;
    this.OwnedProductData.credentialId = this.producDetails.billingClientId;
    this.OwnedProductData.dcmCode = this.producDetails.serviceOfferCode;
    this.licensePricingService.getPricingForOwenedQty(this.OwnedProductData)
      .subscribe(respobj => {
        const productInfo = JSON.parse(sessionStorage.getItem('singleUserDetail'));
        if (respobj.quantity === productInfo.quantity) {
          this.unitPrice = respobj.unitPrice;
          this.ownedProductPrice = respobj.totalPrice;
          this.subscriptionId = respobj.purchaseIdentifier;
          this.pageloaderService.setPageLoaderStatus(true);
          this.setError = false;
          this.showErrLink = false;
          this.showRemoveallLink = false;
          this.ErrorMessage = '';
          this.getUpdatedPricing();
        } else {
          this.setError = true;
          this.showErrLink = false;
          this.showRemoveallLink = false;
          this.ErrorMessage = `<p> We can't process this order because you have other orders pending.</p>
          <p>If you need help, call 1.866.241.6588 (TTY 1.866.6567) Monday - Friday, from 7 a.m. - 9 p.m. 
          ET. You can also chat with an expert during weekday calling hours as well as Saturday and Sunday from 8 a.m. - 5.pm. </p>`;
          this.impoErr = true;
          this.pageloaderService.setPageLoaderStatus(true);
        }
      }, error => {
        this.impoErr = true;
        this.setErrorMessage(error);
      });
  }

  getUpdatedPricing() {
    this.updatedQty = Number(this.modifyLicenseForm.value.qty);
    if (this.producDetails.modifyType === 'Decrease') {
      this.totalQty = Number(this.producDetails.quantity) - this.updatedQty;
      if (this.producDetails.quantity === this.modifyLicenseForm.value.qty) {
        if (!!sessionStorage.getItem('reviewModel') && sessionStorage.getItem('reviewModel') !== undefined) {
          const reviewModel = JSON.parse(sessionStorage.getItem('reviewModel'));
          reviewModel.modifiedLicense = this.updatedQty;
          sessionStorage.setItem('reviewModel', JSON.stringify(reviewModel));
        } else {
          this.producDetails.enteredQty = this.updatedQty;
          sessionStorage.setItem('singleUserDetail', JSON.stringify(this.producDetails));
        }
        this.setError = true;
        this.showErrLink = false;
        this.showRemoveallLink = true;
        this.ErrorMessage = '<span> To cancel the product and remove all licenses, go see</span>';
        this.isFormValid = false;
        this.utilityService.loadFocusOnTop();
        this.updatePricingInfo();
      } else if (this.producDetails.quantity < this.modifyLicenseForm.value.qty) {
        if (!!sessionStorage.getItem('reviewModel') && sessionStorage.getItem('reviewModel') !== undefined) {
          const reviewModel = JSON.parse(sessionStorage.getItem('reviewModel'));
          reviewModel.modifiedLicense = this.updatedQty;
          sessionStorage.setItem('reviewModel', JSON.stringify(reviewModel));
        } else {
          this.producDetails.enteredQty = this.updatedQty;
          sessionStorage.setItem('singleUserDetail', JSON.stringify(this.producDetails));
        }
        this.setError = true;
        this.showErrLink = false;
        this.showRemoveallLink = false;
        this.ErrorMessage = '<span> Remove quantity should be lesser than available quantity.</span>';
        this.priceErr = true;
        this.utilityService.loadFocusOnTop();
        if (this.TotalAmt === 0) {
          this.TotalAmt = this.ownedProductPrice;
        }
      } else {
        this.updatePricingInfo();
      }
    } else {
      this.totalQty = Number(this.producDetails.quantity) + this.updatedQty;
      this.updatePricingInfo();
    }
  }

  updatePricingInfo() {
    this.setError = false;
    this.ErrorMessage = '';
    this.pageloaderService.setPageLoaderStatus(false);
    const dcmArray = [];
    dcmArray.push(this.producDetails.serviceOfferCode);
    this.dataObj.dcmCodes = dcmArray;
    if (this.producDetails.modifyType === 'Increase') {
      this.dataObj.quantity = Number(this.producDetails.quantity) + this.updatedQty;
    } else {
      this.dataObj.quantity = Number(this.producDetails.quantity) - this.updatedQty;
    }
    this.dataObj.fan = this.producDetails.brokerAccountClientId;
    this.licensePricingService.getPricingDetailsByQty(this.dataObj)
      .subscribe(pricingrespobj => {
        this.priceErr = false;
        this.feeType = pricingrespobj[0].feeType;
        this.tmpTotalQty = this.totalQty;
        if (pricingrespobj[0].totalPrice && pricingrespobj[0].totalPrice !== undefined) {
          this.TotalAmt = pricingrespobj[0].totalPrice;
          this.totUnitPrice = (pricingrespobj[0].customPrice) ? pricingrespobj[0].customPrice : pricingrespobj[0].unitPrice;
          this.UpdatedQtyAmt = this.TotalAmt - this.ownedProductPrice;
          this.estimatedAmount = (pricingrespobj[0].applicableDiscount) ? pricingrespobj[0].applicableDiscount : 0;
          this.unitTotalEstimatedAmount = (pricingrespobj[0].totalPriceWithDiscount) ? pricingrespobj[0].totalPriceWithDiscount : 0;
        } else {
          this.TotalAmt = 0;
          this.totUnitPrice = 0;
          this.UpdatedQtyAmt = 0;
        }
        if (pricingrespobj[0].price.length > 0) {
          this.volumeDiscount = pricingrespobj[0].price;
          this.showVolumeDiscunt = true;
        } else {
          this.showVolumeDiscunt = false;
        }
        this.setError = false;
        this.ErrorMessage = '';
        this.pageloaderService.setPageLoaderStatus(true);
        this.initialQty = this.modifyLicenseForm.value.qty;
        this.isFormValid = true;
      }, error => {
        this.priceErr = true;
        this.setErrorMessage(error);
        this.isFormValid = false;
      });
  }

  checkForModifyType() {
    const singleProductdetail = this.producDetails;
    singleProductdetail.enteredQty = this.updatedQty;
    sessionStorage.setItem('singleUserDetail', JSON.stringify(singleProductdetail));
    if (this.producDetails.modifyType === 'Decrease') {
      this.pageloaderService.setPageLoaderStatus(false);
      const serviceUrl = this.utilityService.getEnvConfig().singleProductUrl + this.user.companyId
        + '/inventory/service?quantity=' + Number(this.initialQty) +
        '&billingClientId=' + this.producDetails.billingClientId;
      const data = {
        'class': 'API::ServiceSearchCriteria',
        'fetchCriteria': { 'limit': 20, 'offset': 0, 'sortDir': 'ASC', 'sortField': 'serviceOfferCode' },
        'serviceOfferCodes': [this.producDetails.serviceOfferCode], 'serviceStatus': 'ACTIVE'
      };
      this.licensePricingService.decreaseQtyValidation(serviceUrl, data)
        .subscribe(respobj => {
          if (respobj === false) {
            if (!!sessionStorage.getItem('reviewModel') && sessionStorage.getItem('reviewModel') !== undefined) {
              const reviewModel = JSON.parse(sessionStorage.getItem('reviewModel'));
              reviewModel.modifiedLicense = this.updatedQty;
              sessionStorage.setItem('reviewModel', JSON.stringify(reviewModel));
            }
            this.setError = true;
            this.ErrorMessage = '<span>You attempted to decrease your license by ' + this.initialQty +
              '. You need to unassign users first to decrease this amount</span>';
            this.showRemoveallLink = false;
            this.showErrLink = true;
            this.pageloaderService.setPageLoaderStatus(true);
            this.isFormValid = false;
            this.errorFlag = true;
          } else {
            this.pageloaderService.setPageLoaderStatus(true);
            this.isFormValid = true;
            this.showErrLink = false;
            this.setError = false;
            this.ErrorMessage = '';
            this.reviewOrder();
          }
        }, error => {
          this.setErrorMessage(error);
          this.isFormValid = false;
        });
      // }
    } else {
      this.reviewOrder();
    }
  }

  unassingUserFlow() {
    this.userWizard = new UserWizardModel();
    this.userWizard.source = 'product';
    this.userWizard.previousUrl = this.router.url;
    this.userWizard.actionType = 'UNASSIGN';
    this.userWizard.existingProducts = this.producDetails.specName;

    this.productInfo.productName = this.producDetails.specName;
    this.productInfo.fan = this.producDetails.brokerAccountClientId;
    this.productInfo.ctn = this.producDetails.billingClientId;
    this.productInfo.dcmCode = this.producDetails.serviceOfferCode;
    this.productInfo.clientId = this.producDetails.clientId;

    this.userWizard.product = this.productInfo;
    this.breadCrumbService.removeLastBreadCrumb();
    sessionStorage.setItem('assign-wizard', JSON.stringify(this.userWizard));
    this.router.navigate(['/manageUsers/action']);
  }
  removeAllFlow() {
    this.breadCrumbService.removeLastBreadCrumb();
    this.router.navigate(['/manageProduct/cancel-product']);
  }
  reviewOrder() {
    this.reviewModel = new ReviewOrderProductModel();
    this.reviewModel.product = this.producDetails.specName;
    this.reviewModel.fan = this.producDetails.brokerAccountClientId;
    this.reviewModel.ctn = this.billingClientId;
    this.reviewModel.serviceOfferCode = this.producDetails.serviceOfferCode;
    this.reviewModel.description = this.producDetails.productDesc;
    this.reviewModel.initialLicense = Number(this.producDetails.quantity);
    this.reviewModel.modifiedLicense = this.updatedQty;
    this.reviewModel.unitPrice = this.totUnitPrice;
    this.reviewModel.initialUnitPrice = this.unitPrice;
    this.reviewModel.subscriptionId = this.subscriptionId;
    if (this.producDetails.modifyType === 'Increase') {
      this.reviewModel.totalLicense = Number(this.producDetails.quantity) + this.updatedQty;
    } else {
      this.reviewModel.totalLicense = this.producDetails.quantity - this.updatedQty;
    }
    this.reviewModel.initialAmount = this.ownedProductPrice;
    this.reviewModel.modifiedAmount = this.UpdatedQtyAmt;
    this.reviewModel.type = this.producDetails.modifyType;
    this.reviewModel.estimatedDiscount = this.estimatedAmount;
    this.reviewModel.unitTotalAmount = this.TotalAmt;
    this.reviewModel.totalAmount = this.unitTotalEstimatedAmount > 0 ? this.unitTotalEstimatedAmount : this.TotalAmt;
    sessionStorage.setItem('reviewModel', JSON.stringify(this.reviewModel));
    this.router.navigate(['/manageProduct/revieworderproduct']);
  }

  setErrorMessage(error) {
    this.pageloaderService.setPageLoaderStatus(true);
    if (error.status === 401) {
      this.setError = true;
      this.showRemoveallLink = false;
      this.showErrLink = false;
      this.ErrorMessage = 'Session expired, Please login again.';
      logoutCurrentUser(true);
      this.adobeAnalyticsService.CreateSeriveAlertProperties(error.status, error.statusText, 'formResponse');
    } else if (error.status === 400) {    
      this.setError = true;
      this.showRemoveallLink = false;
      this.showErrLink = false;
      if (this.producDetails.modifyType === 'Increase') {
        if (error.error[0]) {
          this.ErrorMessage = JSON.stringify(error.error[0]);
        } else if (error.error) {
          this.ErrorMessage = error.error;
        } else {
          this.ErrorMessage = 'Can not add more than max-qty';
        }
      } else {
        this.setError = true;
        this.showRemoveallLink = true;
        this.showErrLink = false;
        this.ErrorMessage = '<span> To cancel the product and remove all licenses, go see</span>';
      }
      this.adobeAnalyticsService.CreateSeriveAlertProperties(error.status, error.statusText, 'formResponse', 'Failure_BusinessRule');
    } else if (error.status === 404) {
      this.setError = true;
      if (error.error[0] && error.error[0].errorDescription) {
        this.ErrorMessage = error.error[0].errorDescription;
      } else {
        this.ErrorMessage = 'Products are not available.';
      }
    } else {
      this.setError = true;
      this.showRemoveallLink = false;
      this.showErrLink = false;
      this.ErrorMessage = 'We couldn\'t complete your request. Please try again later.';
      this.adobeAnalyticsService.CreateSeriveAlertProperties(error.status, error.statusText, 'formResponse');
    }
    this.utilityService.loadFocusOnTop();
  }

  handleError(error) {
    throw error;
  }

  ngOnDestroy() {
    this.pageloaderService.setPageLoaderStatus(true);
  }
}
